import axios from "@/api/axios";

async function sendGetPdfReportDataRequest(callBack) {
  let responseData = {
    doctor_number: 0,
    icon: null,
    iconWidth: 0,
    iconHeight: 0,
    iconDataUrl: null,
    patient_first_name: vueApp.patientFirstName,
    patient_last_name: vueApp.patientLastName,
    age: 0,
    cephDate: "" + new Date(),
  };
  try {
    let url = "/api/report/getPdfReportData";
    let requestData = {
      patientId: vueApp.patientId,
      serverTag: vueApp.prefix,
      s3Url: vueApp.s3Url,
    };
    const response = await axios.get(url, { params: requestData });
    responseData = response.data;
  } catch (e) {
    console.log("sendGetPdfReportDataRequest error", e);
  }

  if (callBack) {
    // let iconUrl = data.icon;
    // let blob = await fetch(iconUrl).then((r) => r.blob());
    // let dataUrl = await new Promise((resolve) => {
    //   let reader = new FileReader();
    //   reader.onload = () => resolve(reader.result);
    //   reader.readAsDataURL(blob);
    // });
    // data.iconDataUrl = dataUrl;
    callBack(responseData);
  }
}

async function sendGetExportDataRequest(callBack) {
  let responseData = {
    cbctUrl: null,
    iosUrl: null,
    stitchedUrl: null,
    nonStitchedUrl: null,
    airwayReportUrl: null,
  };
  // https://s3.us-west-2.amazonaws.com/qa.cephx.com/STL/dicom-3175161723626821092/stl_transformed_dicom-3175161723626821092.zip
  responseData.cbctUrl = `${vueApp.dicomUrl}/dicom.zip`;

  if (vueApp.isStitched) {
    // https://s3.us-west-2.amazonaws.com/qa.cephx.com/dicom-3175161723626821092/stlCopy/stl_transformed_dicom-3175161723626821092.zip
    responseData.nonStitchedUrl = `${vueApp.stlCopyUrl}/desktop.zip`;
    responseData.stitchedUrl = `${vueApp.stlBaseUrl}/desktop.zip`;
    // stl_transformed_${vueApp.s3dicom}.zip`;
  } else {
    // https://s3.us-west-2.amazonaws.com/qa.cephx.com/STL/dicom-3175161723626821092/stl_transformed_dicom-3175161723626821092.zip
    responseData.nonStitchedUrl = `${vueApp.stlBaseUrl}/desktop.zip`;
  }

  if (vueApp.isIntraoral) {
    // https://s3.us-west-2.amazonaws.com/qa.cephx.com/STL/dicom-3175161723626821092/stl_segmentation_standalone_dicom-3175161723626821092.zip
    responseData.iosUrl = `${vueApp.stlBaseUrl}/stl_segmentation_standalone_${vueApp.s3dicom}.zip`;
  }

  // https://qa.ceph-x.com/cephx/analysis/download?patnum=317516&docnum=1&patname=STITCHING%20Kea%20Test%2020240814%20&DocName=Zeev%20Abraham&data=Airway%20Volume&showLogo=true
  // responseData.airwayReportUrl = `https://qa.ceph-x.com/cephx/analysis/download?patnum=${vueApp.patientId}`;

  // responseData.nonStitchedUrl = "https://s3.us-west-2.amazonaws.com/qa.cephx.com/STL/dicom-3175161723626821092/stl_transformed_dicom-3175161723626821092.zip?response-content-disposition=attachment%3B%20filename%3D%22case-317516-stl.zip%22&X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Date=20240827T074017Z&X-Amz-SignedHeaders=host&X-Amz-Expires=899&X-Amz-Credential=AKIAWGBWWZKWMBVIQB6V%2F20240827%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Signature=256488af6761ff49e42ae2fb024332f2b1182bea51cad261c5f6ba029816a1fd";
  // https://s3.us-west-2.amazonaws.com/qa.cephx.com/STL/dicom-3175161723626821092/stl_transformed_dicom-3175161723626821092.zip
  // ?response-content-disposition=attachment%3B%20filename%3D%22case-317516-stl.zip%22&X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Date=20240827T074017Z&X-Amz-SignedHeaders=host&X-Amz-Expires=899&X-Amz-Credential=AKIAWGBWWZKWMBVIQB6V%2F20240827%2Fus-west-2%2Fs3%2Faws4_request&X-Amz-Signature=256488af6761ff49e42ae2fb024332f2b1182bea51cad261c5f6ba029816a1fd

  // if (callBack) {
  //   callBack(responseData);
  // }

  try {
    // console.log(
    //   "sendGetExportDataRequest",
    //   vueApp.patientId,
    //   vueApp.prefix,
    //   vueApp.s3Url
    // );
    let url = "/api/report/getExportData";
    let requestData = {
      patientId: vueApp.patientId,
      patientName: `${vueApp.patientFirstName} ${vueApp.patientLastName}`,
      serverTag: vueApp.prefix,
      s3Url: vueApp.s3Url,
      s3dicom: vueApp.s3dicom,
      // isStitched: vueApp.isStitched,
    };
    const response = await axios.get(url, { params: requestData });
    responseData = response.data;
  } catch (e) {
    console.log("sendGetExportDataRequest error", e);
  }
  if (callBack) {
    callBack(responseData);
  }
}

export { sendGetPdfReportDataRequest, sendGetExportDataRequest };
